export const MuiTextField = {
    styleOverrides: {
        root: ({ theme }) => ({
            "& .MuiFormHelperText-root": {
                "&:before": {
                    display: "none"
                },
                "&:not(.Mui-focused):not(.Mui-error)": {
                    visibility: "hidden"
                },
                "&:not(.Mui-error)": {
                    color: theme.palette.primary.main
                }
            }
        })
    }
};
//# sourceMappingURL=TextField.js.map